export const handleServiceDetailsStatusTag = (
  value: string,
): 'success' | 'error' | 'warning' | 'information' => {
  const statusResponse = value?.toUpperCase()?.replaceAll(' ', '_')

  const status = {
    SUCESSO: 'success',
    CONCLUIDO: 'success',
    PENDENTE: 'warning',
    CANCELADO: 'error',
    ERRO: 'error',
    INATIVO: 'neutral',
  }

  return status[statusResponse] || 'information'
}
